// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.broearnWalletModal {
  padding: 24px;
}
.broearn-wallet-title {
  padding-inline: 20px 32px;
  font-size: 22px;
  font-weight: 700;
  line-height: 22px;
  margin-top: 20px;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/cashier/broearnWalletModal/style.less"],"names":[],"mappings":"AAAA;EACI,aAAA;AACJ;AAEA;EACI,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAAJ","sourcesContent":[".broearnWalletModal {\n    padding: 24px;\n}\n\n.broearn-wallet-title {\n    padding-inline: 20px 32px;\n    font-size: 22px;\n    font-weight: 700;\n    line-height: 22px;\n    margin-top: 20px;\n    text-align: center;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
